import { CardMedia } from "@mui/material";
import styles from "./Banner.module.scss";
import { useTranslation } from "react-i18next";

const SingleBanner = ({ coverImage, title }) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <div className={styles.bannerWrapper}>
      {coverImage ? (
        <CardMedia
          component="img"
          alt={title?.[language] ? title?.[language] : ""}
          image={coverImage}
          className={styles.cardMedia}
          loading="lazy"
        />
      ) : null}
    </div>
  );
};

export default SingleBanner;
